export interface LocationPartnerAuthorization {
    id?: string;
    endTimestamp: number;
    location: {
        id: string,
        name?: string
    }
    partner: {
        id: string,
        name?: string
    };
    thingAccessPolicy: LocationPartnerAuthorizationThingAccessPolicy;
    thingIds?: string[];
}

export enum LocationPartnerAuthorizationThingAccessPolicy {
    GRANT_ALL = 'GRANT_ALL',
    LIMITED = 'LIMITED'
}
